import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    serverPackageId: null
}

const serverSlice = createSlice({
    name: "ServerSlice",
    initialState,
    reducers: {
        setServerPackage(state, { payload }) {
            state.serverPackageId = payload
        },
    }
})

export const serverReducer = serverSlice.reducer
export const { setServerPackageIdsad } = serverSlice.actions
